<template>
  <div class="content">
    <div class="grid-container" :class="gridColsClass">
      <div
          v-for="(item, i) in visibleItems"
          :key="i"
          class="item-card"
      >
        <img :src="`${imgDomain}/${item.doc_url}`" alt="" />
        <div class="info">
          <div class="title">{{ item.title }}</div>
          <div class="price">
            <div class="price__title">Normal price:</div>
            <div class="price__value">{{ item.price }} {{ currency }}</div>
          </div>
          <router-link :to="{name: 'ProductPage', params: {id: item.id}}" class="button blue view-btn">
            View
          </router-link>
        </div>
      </div>
    </div>

    <button
        v-if="!allShown"
        class="show-more"
        @click="showMore"
    >
      Show More
      <span class="arrow">▼</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "ImageBundleInside",
  props: {
    items: {
      type: Array,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      imgDomain: process.env.VUE_APP_STATIC_DOMAIN,
      displayedCount: 0,
    };
  },
  computed: {
    // slice of items to render
    visibleItems() {
      return this.items.slice(0, this.displayedCount);
    },
    allShown() {
      return this.displayedCount >= this.items.length;
    },
    // set CSS class for columns (optional, you could rely solely on media-queries)
    gridColsClass() {
      const w = window.innerWidth;
      if (w >= 1024) return "cols-4";
      if (w >= 640) return "cols-2";
      return "cols-1";
    },
  },
  methods: {
    setInitialCount() {
      const w = window.innerWidth;
      if (w >= 1024) {
        this.displayedCount = 8;
      } else if (w >= 640) {
        this.displayedCount = 4;
      } else {
        this.displayedCount = 1;
      }
    },
    onResize() {
      // re-compute only if we haven't already shown "all"
      if (!this.allShown) {
        this.setInitialCount();
      }
    },
    showMore() {
      this.displayedCount = this.items.length;
    },
  },
  mounted() {
    this.setInitialCount();
    window.addEventListener("resize", this.onResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped lang="scss">
.bundle-inside {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content {
  .show-more {
    background: transparent;
    color: #022759;
    text-transform: uppercase;
    font-weight: bold;

    &:hover {
      //background: transparent;
    }

    .arrow {
      transform: scale(1.2, 0.6); // wider, shorter
      display: inline-block; // needed for transform to apply
      font-size: 17px;
    }
  }
}

.grid-container {
  display: grid;
  gap: 1rem;
  column-gap: 30px;
  row-gap: 31px;

  &.cols-1 {
    grid-template-columns: repeat(1, 1fr);
  }
  &.cols-2 {
    grid-template-columns: repeat(2, 1fr);
  }
  &.cols-4 {
    grid-template-columns: repeat(4, 1fr);
  }

  /* ensure the grid grows to hold exactly two rows on md/lg initial states */
  &.cols-2 {
    /* two rows of 2 items → 4 total visible */
    grid-auto-rows: 1fr;
  }
  &.cols-4 {
    /* two rows of 4 items → 8 total visible */
    grid-auto-rows: 1fr;
  }
}

.item-card {
  //border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
    border-radius: 8px;
  }

  .info {
    padding: 0.5rem;
    display: flex;
    flex-direction: column;
    row-gap: 12px;


    .title {
      text-align: left;
      font-size: 14px;
      line-height: 19px;
      color: #000000;
      font-family: "Open Sans", sans-serif;
      font-weight: bold;
    }
    .price {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 14px;
      color: #555;

      &__title {
        color: #818990;
        font-family: "Open Sans", sans-serif;
        font-size: 12px;
        line-height: 17px
      }

      &__value {
        color: #022759;
        font-family: "Kanit", sans-serif;
        font-weight: bold;
      }
    }

    > button {
      margin-top: 2px;
    }
  }
}

.show-more {
  margin-top: 1rem;
  padding: 0.5rem 1.25rem;
  font-size: 1rem;
  background: #3478f6;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: #245ec9;
  }
}
</style>
